import CloseIcon from '@mui/icons-material/Close';
import { Box, Button } from '@mui/material';
import {
  USER_ROLES,
  UserRoleType,
  saveGlobalToggleState,
} from '@pwc/pwc-deals-web-common';
import {
  getActualUserRole,
  getUserRole,
  setUserRole,
} from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useGlobalToggle } from './GlobalToggle';

const viewAsLabel: {
  [key in UserRoleType]: string;
} = {
  [USER_ROLES.CLIENT]: 'client',
  [USER_ROLES.PWC_USER]: 'PwC user',
  [USER_ROLES.THIRD_PARTY]: 'third party',
};

export const GlobalToggleOutline = () => {
  const dispatch = useDispatch();
  const userRole = useSelector(getUserRole) as UserRoleType;
  const actualPwcUser = useSelector(getActualUserRole) === USER_ROLES.PWC_USER;
  const { afterUserRoleChanged } = useGlobalToggle();

  return (
    <>
      {userRole === USER_ROLES.CLIENT && actualPwcUser ? (
        <>
          <Box
            sx={{
              border: '4px solid #F4B940',
              content: '""',
              position: 'fixed',
              zIndex: 8,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              pointerEvents: 'none',
            }}
          />
          <Box
            sx={{
              position: 'fixed',
              zIndex: 8,
              top: 0,
              left: 'calc(50% - 114px)',
              background: '#F4B940',
              borderRadius: '0px 0px 4px 4px',
              color: '#000',
              p: '0 1rem',
              fontSize: '0.875rem',
              lineHeight: '34px',
            }}
          >
            Viewing as {viewAsLabel[userRole]}
            <Box
              component="span"
              sx={{
                display: 'inline-block',
                position: 'relative',
                top: '0.05rem',
                mx: '0.5rem',
              }}
            >
              |
            </Box>{' '}
            <Button
              variant="text"
              size="small"
              sx={{
                color: '#000',
                p: 0,
                lineHeight: 1,
                fontSize: '0.875rem',
                fontWeight: 400,
                minWidth: 0,
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
                '& .MuiButton-endIcon': {
                  marginTop: '-0.05rem',
                  marginLeft: '0.25rem',
                },
              }}
              onClick={() => {
                dispatch(setUserRole(USER_ROLES.PWC_USER));
                saveGlobalToggleState(USER_ROLES.PWC_USER);
                afterUserRoleChanged(USER_ROLES.PWC_USER);
              }}
              endIcon={<CloseIcon />}
            >
              <Box
                sx={{
                  position: 'relative',
                  top: '-0.05rem',
                }}
                component="span"
              >
                Exit
              </Box>
            </Button>
          </Box>
        </>
      ) : null}
    </>
  );
};
